import { server } from '@/helpers';

export type HomepageSection = {
  id: number;
  type: string;
  title: string;
  orderLoggedIn: number | null;
  visibleLoggedIn: boolean;
  orderLoggedOut: number | null;
  visibleLoggedOut: boolean;
};

const getSections = (): Promise<{ sections: HomepageSection[] }> =>
  server.request.get('/homepage/support/sections').then(server.handleSuccess).catch(server.handleError);

const updateSections = (sections: HomepageSection[]): Promise<{ sections: HomepageSection[] }> =>
  server.request.post('/homepage/support/sections', { sections }).then(server.handleSuccess).catch(server.handleError);

export type HomepageAdminUser = {
  id: number;
  name: string;
  email: string;
  isAdmin: number | null;
};

const getAdminUsers = (): Promise<{ users: HomepageAdminUser[]; canEditRoles: boolean }> =>
  server.request.get('/homepage/support/admin-users').then(server.handleSuccess).catch(server.handleError);

const findUserByEmail = (email: string): Promise<HomepageAdminUser | { user: null }> =>
  server.request
    .get(`/homepage/support/users?email=${encodeURIComponent(email)}`)
    .then(server.handleSuccess)
    .catch(server.handleError);

const setUserRole = (id: number, isAdmin: number | null): Promise<HomepageAdminUser> =>
  server.request
    .post('/homepage/support/set-user-role', { id, isAdmin })
    .then(server.handleSuccess)
    .catch(server.handleError);

export const homepageServices = {
  getSections,
  updateSections,
  getAdminUsers,
  findUserByEmail,
  setUserRole,
};
